import { StyleSheet, Text, View } from 'react-native';

import { fontSize, radius, spacing } from '@/constants/theme';
import type { AgreementStatus } from '@/lib/database.types';
import { statusColor, statusLabel } from '@/lib/format';

export function StatusBadge({ status, muted = false }: { status: AgreementStatus; muted?: boolean }) {
  const color = statusColor(status);
  return (
    <View style={[styles.badge, { borderColor: color, backgroundColor: color + '20', opacity: muted ? 0.55 : 1 }]}>
      <View style={[styles.dot, { backgroundColor: color }]} />
      <Text style={[styles.label, { color }]}>{statusLabel(status)}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    borderWidth: 1.5,
    borderRadius: radius.full,
    paddingVertical: 4,
    paddingHorizontal: spacing.sm,
    alignSelf: 'flex-start',
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: 4,
  },
  label: {
    fontSize: fontSize.sm,
    fontWeight: '700',
  },
});
